import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class KnowledgeBaseFileRepositoryService extends BaseRepositoryService<
  ModelRegistry['ai-knowledge-base-file']
> {
  recordName = 'ai-knowledge-base-file';
  implementMethods = ['findAll', 'createRecord', 'destroyRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/ai-knowledge-base-file': KnowledgeBaseFileRepositoryService;
  }
}
